import React from 'react';

import PropTypes from 'prop-types';
import {
  SummarySidebarContentProvider,
} from 'Views/Page/Content/Templates/WhatIfTemplate/Content/LeftSide/Content/DetailPicker/Details/Context';
import Container from './Container';

const AvailableResourcesComponent = ({ tabDataRelationship }) => {
  return (
    <SummarySidebarContentProvider>
      <Container relationship={tabDataRelationship} />
    </SummarySidebarContentProvider>
  );
};

AvailableResourcesComponent.propTypes = {
  tabDataRelationship: PropTypes.object.isRequired,
};

export default AvailableResourcesComponent;
